
import React from 'react'

import Article from '../components/News/article'

import { getLocalization } from '../localization'

import '../fragments'


class ArticlePage extends React.Component {

  render() {
    const article = this.props.data.contentfulNewsArticle
    const locale = article.node_locale
    const lang = locale === 'fi-FI' ? 'fi' : 'en'
    const localization = getLocalization(this.props.data.globalLocalization, locale)

    if (!article) {
      return null
    } else {
      return (
        <Article content={ article } localization={ localization } lang={ lang } />
      )
    }
  }
}


export default ArticlePage

export const pageQuery = graphql`
query articleQuery( $id : String!) {
  globalLocalization: allContentfulLocalizationString(filter: {key: {regex: "/^global/" }}) {
    edges {
      node { 
        key
        text
        node_locale
      }
    }
  }

  contentfulNewsArticle: contentfulNewsArticle(id: {eq: $id}) {
    node_locale
    createdAt(formatString: "MMM D, YYYY")
    heading
    body {
      body
    }
    id
    backgroundColor
    featureImage {
      title
      sizes(maxWidth: 2560) {
        ...GatsbyContentfulSizes_withWebp
      }
    }
  }
}
`


// WEBPACK FOOTER //
// ./src/templates/article.js